export default {
  COURTS: 'courts',
  DASHBOARD: 'dashboard',
  MANAGERS: 'managers',
  MEMBERS: 'members',
  RESERVATIONS: 'reservations',
  SETTINGS: 'settings',
};
